<template>
  <div>
    <profile-basic-data-card
      @update-email="emailUpdated"
      :readonly="readonly"
    />

    <profile-attributes-list
      @attribute-updated="attributeUpdated"
      :readonly="readonly"
    />

    <profile-categorised-attributes-list
      v-if="categorisedAttributesEnabled"
      :readonly="readonly"
    />

    <profile-aggregates-list v-if="aggregatesEnabled" :readonly="readonly" />
  </div>
</template>

<script>
import ProfileBasicDataCard from '@/modules/profiles/components/ProfileBasicDataCard'
import ProfileAttributesList from '@/modules/profiles/components/ProfileAttributesList'
import ProfileCategorisedAttributesList from '@/modules/profiles/components/ProfileCategorisedAttributesList'
import ProfileAggregatesList from '../components/ProfileAggregatesList'
import { $hasFeature } from '../../../core/utils/VueAcl'

export default {
  name: 'ProfileDataPage',

  components: {
    ProfileAggregatesList,
    ProfileBasicDataCard,
    ProfileAttributesList,
    ProfileCategorisedAttributesList
  },

  props: {
    readonly: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    emailUpdated(newEmail) {
      this.$emit('email-updated', newEmail)
    },

    attributeUpdated(attributeModel) {
      this.$emit('attribute-updated', attributeModel)
    }
  },

  computed: {
    aggregatesEnabled() {
      return $hasFeature('aggregatesEnabled')
    },

    categorisedAttributesEnabled() {
      return (
        $hasFeature('tagCategories') &&
        this.$can('CategorisedAttributeValue::Read')
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/profiles/pages/ProfileDataPage.vue